module.exports = __webpack_public_path__ + "static/media/client.580bef44.svg";